export default __webpack_public_path__ + "static/media/tf_logo.ecc7edd5.svg";